import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'

import { reload } from 'actions/core/navigation'

export const ErrorModal = () => (
  <Popup
    isBlocking
    onClose={reload}
    title={I18n.t('errors.default_no_action')}
  >
    <Body>
      {I18n.t('errors.server.request')}
    </Body>
    <Footer>
      <Button onClick={reload}>
        {I18n.t('publisher.action.reload_page')}
      </Button>
    </Footer>
  </Popup>
)
